import { render } from "./InvestmentSidebarEditor.vue?vue&type=template&id=c00d0064&scoped=true"
import script from "./InvestmentSidebarEditor.vue?vue&type=script&lang=js"
export * from "./InvestmentSidebarEditor.vue?vue&type=script&lang=js"

import "./InvestmentSidebarEditor.vue?vue&type=style&index=0&id=c00d0064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c00d0064"]])

export default __exports__